import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

// Import des composants
import Login from '../views/auth/Login'

import AccountEdit from '../views/account/AccountEdit'
import AccountShow from '../views/account/AccountShow'

import UserIndex from '../views/user/UserIndex'
import UserShow from '../views/user/UserShow'
import UserCreate from '../views/user/UserCreate'
import UserEdit from '../views/user/UserEdit'

import ProjectIndex from '../views/project/ProjectIndex'
import ProjectShow from '../views/project/ProjectShow'
import ProjectCreate from '../views/project/ProjectCreateEdit.vue'
import ProjectEdit from '../views/project/ProjectCreateEdit.vue'

import ProjectTypeCreate from "../views/projectType/ProjectTypeCreate.vue"
import ProjectTypeIndex from "../views/projectType/ProjectTypeIndex.vue"
import ProjectTypeEdit from "../views/projectType/ProjectTypeEdit.vue"

import CommissionIndex from "../views/commission/CommissionIndex.vue"
import CommissionCreate from "../views/commission/CommissionCreate.vue"
import CommissionEdit from "../views/commission/CommissionEdit.vue"

Vue.use(VueRouter)

const routes = [
  // Route de login
  {
    path: '/login/:component?/:token?/:userId?',
    name: 'Login',
    component: Login,
    meta: {
      guest: true
    }
  },

  // Page d'accueil
  {
    path: '/',
    name: '/',
    component: ProjectIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_COMMISSION', 'ROLE_USER']
    }
  },

  // Mon compte
  {
    path: '/account/show',
    name: 'AccountShow',
    component: AccountShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_COMMISSION', 'ROLE_USER']
    }
  },
  {
    path: '/account/edit',
    name: 'AccountEdit',
    component: AccountEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_COMMISSION', 'ROLE_USER']
    }
  },

  // Gestion des utilisateurs
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/user/show/:userId',
    name: 'UserShow',
    component: UserShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/user/create',
    name: 'UserCreate',
    component: UserCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/user/edit/:userId',
    name: 'UserEdit',
    component: UserEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },

  // Gestion des projets
  {
    path: '/project/index',
    name: 'ProjectIndex',
    component: ProjectIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_COMMISSION', 'ROLE_USER']
    }
  },
  {
    path: '/project/show/:projectId',
    name: 'ProjectShow',
    component: ProjectShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_COMMISSION', 'ROLE_USER']
    }
  },
  {
    path: '/project/create',
    name: 'ProjectCreate',
    component: ProjectCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_USER']
    }
  },
  {
    path: '/project/edit/:projectId',
    name: 'ProjectEdit',
    component: ProjectEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_COMMISSION', 'ROLE_USER']
    }
  },

  // Types de projets
  {
    path: '/projecttype/create',
    name: 'ProjectTypeCreate',
    component: ProjectTypeCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/projecttype/index',
    name: 'ProjectTypeIndex',
    component: ProjectTypeIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/projecttype/edit/:projectTypeId',
    name: 'ProjectTypeEdit',
    component: ProjectTypeEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },

  // Gestion des commissions
  {
    path: '/commission/index',
    name: 'CommissionIndex',
    component: CommissionIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/commission/create',
    name: 'CommissionCreate',
    component: CommissionCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/commission/edit/:commissionId',
    name: 'CommissionEdit',
    component: CommissionEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    window.scrollTo(0,0);
  }
})

// Middleware pour vérifier l'authentification et les rôles
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Vérifie si l'utilisateur est authentifié et a les bons rôles
    const hasAccess = to.matched.some(record => {
      return record.meta.roles && store.getters.roles.some(role => record.meta.roles.includes(role)) && store.getters.isAuthenticated
    })

    if (hasAccess) {
      next()
    } else if (store.getters.isAuthenticated) {
      next('/')  // Redirige vers la page d'accueil si authentifié mais sans rôle approprié
    } else {
      next('/login')  // Redirige vers la page de login si non authentifié
    }
  } else {
    next()  // Passe à la route suivante si elle ne nécessite pas d'authentification
  }
})

// Middleware pour empêcher l'accès des utilisateurs authentifiés aux routes réservées aux invités
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/')  // Redirige vers la page d'accueil si déjà authentifié
    } else {
      next()  // Autorise l'accès si non authentifié
    }
  } else {
    next()  // Passe à la route suivante
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js